import {
  i
} from "./chunk.775UL347.js";

// src/components/icons/jb-mail-icon/jb-mail-icon.css.ts
var jb_mail_icon_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{color:inherit;display:block;height:var(--icon-size, 18px);width:var(--icon-size, 18px)}svg{height:var(--icon-height, 18px);transition:var(--icon-transition, none);width:var(--icon-width, 18px)}`;

export {
  jb_mail_icon_css_default
};
